module.exports = __webpack_public_path__ + "static/media/blog2.e677cba5.jpeg";